"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38],{

/***/ 82764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ MetaHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(51759);
;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/home.ts
var homeBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Главная\",\n      \"item\": \"https://bile-bile.kz/\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/org.ts
var orgSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"Organization\",\n  \"name\": \"Bile-bile\",\n  \"logo\": \"https://bile-bile.kz/og-image.png\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"address\": {\n    \"@type\": \"PostalAddress\",\n    \"addressCountry\": \"Kazakhstan\"\n  },\n  \"sameAs\": []\n}";

;// CONCATENATED MODULE: ./schemas/org/web.ts
var webSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebSite\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"potentialAction\": {\n    \"@type\": \"SearchAction\",\n    \"target\": \"https://bile-bile.kz/search?origin={search_term_string}\",\n    \"query-input\": \"required name=search_term_string\"\n  }\n}";

;// CONCATENATED MODULE: ./schemas/org/faq.ts
var faqSchema = "{\n      \"@context\": \"http://schema.org/\",\n      \"@type\": \"FAQPage\",\n      \"mainEntity\": [\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Хочу купить билет для ребёнка. Сколько стоит детский ж/д билет на поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Дети до 7 лет путешествуют на поезде бесплатно без предоставления отдельного места. Если детей до 7 лет двое или более, необходимо купить детский билет.  Для детей от 7 до 15 лет действует скидка в размере 50% от цены взрослого билета.  Для покупки детского билета понадобится свидетельство о рождении, удостоверяющее личность ребёнка. Если ребёнок едет не с родителями, нужно оформить доверенность на сопровождение.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я хочу забронировать билет на поезд. Сколько времени действует бронь?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Бронь на ж/д билет действует 30 минут. 15 минут на ввод данных пассажира и 15 минут на оплату.  После этого нужно заново забронировать билет.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"На что обратить внимание при выборе ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Рекомендуем обратить внимание на несколько важных моментов при бронировании ж/д билетов:  \xb7 Тип вагона: плацкарт, купе  От выбранного типа зависит стоимость билета и уровень комфорта во время поездки;  \xb7 Выбор места.  Вы можете выбрать любое место в вагоне. В плацкартных вагонах места у туалета с 33 до 38 номера, а в купейных -- с 33 по 36. Во всех поездах нижние полки -- это нечетные места, а верхние -- четные.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал ошибку в личных данных при покупке ж/д билета. Что делать?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Если вы допустили ошибку в билете на поезд, сделайте возврат билета c главной страницы Bile-Bile → Возврат билета и оформите новый.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое максимальное количество билетов я могу приобрести в рамках оформления заказа?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"В рамках оформления заказа допускается приобретение 12 билетов. При необходимости увеличения количества билетов, необходимо оформить новый заказ\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Какое подтверждение я получу после оплаты ж/д билета?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \" Подтверждением заказа служит электронный билет, который вы получите после оплаты брони.  Мы также отправим билет на электронную почту или посредством SMS на реквизиты указанные при заказе билета  Электронный билет всегда доступен с главной страницы Bile-Bile → Печать билета и оформите новый\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Необходимо ли иметь при себе билет при посадке в поезд?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"На наши поезда осуществляется посадка пассажира без необходимости предъявления билета (для резидентов РК по бар-коду удостоверения личности, на которое оформлялся заказ билета)\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я сделал возврат ж/д билета, купленного на Bile-Bile. Когда мне вернут деньги?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата билета.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Как мне вернуть билет, если его за меня купил кто-то другой?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Возврат билета оформляется c главной страницы Bile-Bile → Возврат билета, по реквизитам оформителя.\"\n          }\n        },\n        {\n          \"@type\": \"Question\",\n          \"name\": \"Я собираюсь вернуть неиспользованный билет, на что обратить внимание?\",\n          \"acceptedAnswer\": {\n            \"@type\": \"Answer\",\n            \"text\": \"Формирование запроса на возврат Билета  Возврат Билета производится круглосуточно через функционал Сайта. Возможно производить возврат одного или нескольких Билетов в Заказе.  Для возврата неиспользованного Билета необходимо пройти в раздел \xabВозврат билета\xbb, авторизоваться посредством указания электронного адреса или телефона, указанного во время оформления Билета и следовать дальнейшим инструкциям.  Возврат платежей по Билетам, приобретенным по платежным картам, производится на банковский карт-счет, с которого производилась оплата, в течение 5 (пяти) рабочих дней с момента получения подтверждения возврата Билета.  При оформлении возврата билета, сумма, уплаченная за Дополнительные услуги, возврату не подлежит.  Порядок удержания сумм при возврате Билета  За неиспользованные Билеты и несостоявшуюся вследствие этого перевозку багажа Перевозчик возвращает Пассажиру деньги в следующих случаях:  \xb7 не позднее, чем за 24 часа до отправления поезда - полную стоимость проезда;  \xb7 менее чем за 24 часа, но не позднее, чем за 6 (шесть) часов до отправления поезда - стоимость билета и 50 % (пятидесяти) стоимости плацкарты;  \xb7 менее чем за 6 часов до отправления и не более 1 (одного) часа после отправления поезда - стоимость билета, при этом удерживается вся стоимость плацкарты, но не более 30% от стоимости проезда.  По истечении 1 (одного) часа после отправления поезда возврат Билета не производится, денежные средства не возвращаются.\"\n          }\n        }\n      ]\n    }";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/faq.ts
var faqBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"FAQ\",\n      \"item\": \"https://bile-bile.kz/faq\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/covid.ts
var covidBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"COVID-19\",\n      \"item\": \"https://bile-bile.kz/covid\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/contacts.ts
var contactsBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Контакты\",\n      \"item\": \"https://bile-bile.kz/contacts\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./schemas/org/search.ts
var buildSearchSchema = function(param) {
    var origin = param.origin, destination = param.destination, departureTime = param.departureTime, arrivalTime = param.arrivalTime;
    return "{\n  \"@context\": \"https://schema.org\",\n  \"@type\": \"TrainReservation\",\n  \"reservationId\": \"AB3XY2\",\n  \"reservationStatus\": \"https://schema.org/ReservationConfirmed\",\n  \"reservationFor\": {\n    \"@type\": \"TrainTrip\",\n    \"departureStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"".concat(origin, "\"\n    },\n    \"departureTime\": \"").concat(departureTime, "\",\n    \"arrivalStation\": {\n      \"@type\": \"TrainStation\",\n      \"name\": \"").concat(destination, "\"\n    },\n    \"arrivalTime\": \"").concat(arrivalTime, "\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/landing.ts
var buildLandingSchema = function(param) {
    var origin = param.origin, destination = param.destination;
    return "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"WebPage\",\n  \"url\": \"https://bile-bile.kz/\",\n  \"name\": \"Купить дешевые ж/д билеты по направлению ".concat(origin, " - ").concat(destination, " | bile-bile.kz\",\n  \"description\": \"Bile-bile.kz ➤ дешевые ж/д билеты по направлению ").concat(origin, " - ").concat(destination, " ➤ Узнайте расписание, цены и покупайте железнодорожные билеты по выгодной цене.\",\n  \"publisher\": {\n    \"@type\": \"ProfilePage\",\n    \"name\": \"Bile-bile.kz - ТОО \xabNur-Kassa\xbb\"\n  }\n}");
};

;// CONCATENATED MODULE: ./schemas/org/breadcrumbs/routes.ts
var routesBreadcrumbsSchema = "{\n  \"@context\": \"http://schema.org/\",\n  \"@type\": \"BreadcrumbList\",\n  \"itemListElement\": [\n    {\n      \"@type\": \"ListItem\",\n      \"position\": 1,\n      \"name\": \"Все станции по направлениям\",\n      \"item\": \"https://bile-bile.kz/napravleniya\"\n    }\n  ]\n}";

;// CONCATENATED MODULE: ./components/shared/MetaHead/component.tsx

/* eslint-disable react/no-danger */ 



var SITE_URL = "https://bile-bile.kz" || 0;
var KZ_SITE_URL = "".concat(SITE_URL, "/kk");
var getSchemasByPage = function(page, extra) {
    if (page === 'home') return [
        homeBreadcrumbsSchema,
        orgSchema,
        webSchema
    ];
    if (page === 'faq') return [
        faqSchema,
        faqBreadcrumbsSchema
    ];
    if (page === 'covid') return [
        covidBreadcrumbsSchema
    ];
    if (page === 'contacts') return [
        contactsBreadcrumbsSchema
    ];
    if (page === 'search' || page === 'searchMulti') return [
        buildSearchSchema(extra)
    ];
    if (page === 'landing') return [
        buildLandingSchema(extra)
    ];
    if (page === 'routes') return [
        routesBreadcrumbsSchema
    ];
    return [];
};
var MetaHead = function(param) {
    var page = param.page, _extraParams = param.extraParams, extraParams = _extraParams === void 0 ? {} : _extraParams;
    var ref = (0,useTranslation/* default */.Z)('meta'), t = ref.t, lang = ref.lang;
    var router = (0,next_router.useRouter)();
    var title = t("".concat(page, ".title"), extraParams);
    var description = t("".concat(page, ".description"), extraParams);
    var pageSchemas = getSchemasByPage(page, extraParams);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "meta-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og-title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "og-website"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og-description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: "".concat(lang === 'ru' ? SITE_URL : KZ_SITE_URL).concat(router.asPath)
            }, "og-url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: "".concat(SITE_URL, "/og-image.png")
            }, "og-image"),
            pageSchemas.map(function(schema, idx) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("script", {
                    id: "schema-".concat(idx),
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(JSON.parse(schema))
                    }
                }, schema);
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/shared/MetaHead/index.ts



/***/ }),

/***/ 41001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Loader/index.ts + 2 modules
var Loader = __webpack_require__(67022);
// EXTERNAL MODULE: ./components/ui/Typography/index.ts + 2 modules
var Typography = __webpack_require__(59253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 7 modules
var polished_esm = __webpack_require__(95044);
// EXTERNAL MODULE: ./styles/mixins/indent/indent.ts
var indent = __webpack_require__(81);
;// CONCATENATED MODULE: ./components/ui/Button/styles.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  border: 1px solid;\n  transition: 0.3s ease;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  cursor: not-allowed;\n  border-color: ",
        ";\n  background: ",
        ";\n  .button-typography {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  pointer-events: none;\n  cursor: not-allowed;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1;\n  user-select: none;\n  transition: all 0.3s ease;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 5px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  border-radius: 12px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-color: ",
        ";\n  box-shadow: 0 8px 10px ",
        ",\n    0 3px 14px ",
        ", 0 4px 5px ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-color: ",
        ";\n  box-shadow: none;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n        border: none;\n        background: none;\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      &:hover {\n        ",
        "\n      }\n      &:active {\n        ",
        "\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n        border-color: ",
        ";\n        background-color: ",
        ";\n        ",
        "\n      "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n      ",
        "\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n  \n  &:hover {\n    ",
        "\n  }\n\n  &:active {\n    ",
        "\n  }\n\n  &[disabled] {\n    ",
        "\n  }\n\n  ",
        "\n\n  .button-typography {\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: hidden;\n      opacity: 0;\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  transition: all 0.3s ease;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: visible;\n      opacity: 1;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  transition: all 0.3s ease;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  visibility: hidden;\n  opacity: 0;\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
var coreButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject());
};
var hoverButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.palette.text.ALTERNATIVE;
    });
};
var activeButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.palette.text.ALTERNATIVE;
    });
};
var disabledButtonStyles = function(fill) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), function(param) {
        var theme = param.theme;
        return theme.palette.core.LIGHT_GRAY;
    }, function(param) {
        var theme = param.theme;
        return fill === 'outlined' ? theme.palette.core.TRANSPARENT : theme.palette.core.LIGHT_GRAY;
    }, function(param) {
        var theme = param.theme;
        return fill === 'outlined' ? theme.palette.text.DEEP_GRAY : theme.palette.text.ALTERNATIVE;
    });
};
var loadingButtonStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
};
var typographyStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
};
var flatVariantStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), (0,indent/* indent */.W)('padding', {
        vertical: 8.5,
        horizontal: 35
    }));
};
var regularVariantStyles = function(size) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), (0,indent/* indent */.W)('padding', {
        top: size === 'sm' ? 8 : 14,
        left: size === 'xl' ? 58 : 30,
        right: size === 'xl' ? 58 : 30,
        bottom: size === 'sm' ? 8 : 14
    }));
};
var textVariantStyles = function() {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
};
var hoverStyles = function(hoverColor) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), hoverColor, hoverColor, (0,polished_esm/* transparentize */.DZ)(0.86, hoverColor), (0,polished_esm/* transparentize */.DZ)(0.88, hoverColor), (0,polished_esm/* transparentize */.DZ)(0.8, hoverColor));
};
var activeStyles = function(hoverColor) {
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), (0,polished_esm/* lighten */.$n)(0.1, hoverColor), (0,polished_esm/* lighten */.$n)(0.1, hoverColor));
};
var Wrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5c5cb83c-0"
})(_templateObject15(), function(param) {
    var width = param.width;
    return width ? "".concat(width, "px") : 'auto';
}, coreButtonStyles(), function(param) {
    var variant = param.variant, size = param.size;
    if (variant === 'flat') return flatVariantStyles();
    if (variant === 'text') return textVariantStyles();
    return regularVariantStyles(size);
}, function(param) {
    var fill = param.fill, rawColor = param.color, rawHoverColor = param.hoverColor, theme = param.theme, variant = param.variant;
    if (variant === 'text') return (0,styled_components_browser_esm/* css */.iv)(_templateObject11());
    var color = rawColor || theme.palette[fill === 'outlined' ? 'primary' : 'secondary'].MAIN;
    var hoverColor = rawHoverColor || theme.palette.secondary.MAIN;
    var effects = (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), hoverStyles(hoverColor), activeStyles(hoverColor));
    if (fill === 'outlined') return (0,styled_components_browser_esm/* css */.iv)(_templateObject13(), color, theme.palette.core.TRANSPARENT, effects);
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject14(), color, color, effects);
}, hoverButtonStyles(), activeButtonStyles(), function(param) {
    var fill = param.fill;
    return disabledButtonStyles(fill);
}, function(param) {
    var isLoading = param.isLoading;
    return isLoading && loadingButtonStyles();
}, typographyStyles());
var ButtonContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5cb83c-1"
})(_templateObject17(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject16());
});
var LoaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5cb83c-2"
})(_templateObject19(), function(param) {
    var isLoading = param.isLoading;
    return isLoading && (0,styled_components_browser_esm/* css */.iv)(_templateObject18());
});

;// CONCATENATED MODULE: ./components/ui/Button/component.tsx





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var getTypographyColor = function(fill, theme, textColor) {
    if (textColor) return textColor;
    return fill === 'contained' ? theme.palette.text.ALTERNATIVE : theme.palette.text.MAIN;
};
var Button = function(_param) {
    var children = _param.children, _fill = _param.fill, fill = _fill === void 0 ? 'contained' : _fill, _variant = _param.variant, variant = _variant === void 0 ? 'regular' : _variant, _size = _param.size, size = _size === void 0 ? 'default' : _size, textColor = _param.textColor, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, color = _param.color, _type = _param.type, type = _type === void 0 ? 'button' : _type, props = _objectWithoutProperties(_param, [
        "children",
        "fill",
        "variant",
        "size",
        "textColor",
        "isLoading",
        "color",
        "type"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var typographyColor = getTypographyColor(fill, theme, textColor);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpread({
        fill: fill,
        variant: variant,
        size: size,
        isLoading: isLoading,
        color: color,
        type: type
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContent, {
                isLoading: isLoading,
                children: [
                    typeof children === 'string' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        className: "button-typography",
                        color: typographyColor,
                        typography: theme.typography.variants.button.MAIN,
                        title: children,
                        children: children
                    }),
                    typeof children !== 'string' && children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrapper, {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: typographyColor
                })
            })
        ]
    })));
};


;// CONCATENATED MODULE: ./components/ui/Button/index.ts



/***/ }),

/***/ 83055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Grid; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./utilities/isNumber/isNumber.ts
var isNumber = __webpack_require__(15605);
// EXTERNAL MODULE: ./utilities/pixelize/pixelize.ts
var pixelize = __webpack_require__(60548);
;// CONCATENATED MODULE: ./styles/mixins/grid/container.ts



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  ",
        "\n  ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var gridContainer = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _inlineGrid = ref.inlineGrid, inlineGrid = _inlineGrid === void 0 ? false : _inlineGrid, cols = ref.cols, rows = ref.rows, areas = ref.areas, gap = ref.gap, rowGap = ref.rowGap, columnGap = ref.columnGap, justify = ref.justify, align = ref.align, alignContent = ref.alignContent, justifyContent = ref.justifyContent, autoColumns = ref.autoColumns, autoRows = ref.autoRows, autoFlow = ref.autoFlow;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), inlineGrid ? 'inline-grid' : 'grid', cols ? "grid-template-columns: ".concat((0,isNumber/* isNumber */.h)(cols) ? "repeat(".concat(cols, ", 1fr)") : cols, ";") : '', rows ? "grid-template-rows: ".concat((0,isNumber/* isNumber */.h)(rows) ? "repeat(".concat(rows, ", 1fr)") : rows, ";") : '', areas ? "grid-template-areas: ".concat(areas) : '', gap ? "gap: ".concat((0,isNumber/* isNumber */.h)(gap) ? (0,pixelize/* pixelize */.P)(gap) : gap, ";") : '', rowGap ? "row-gap: ".concat((0,isNumber/* isNumber */.h)(rowGap) ? (0,pixelize/* pixelize */.P)(rowGap) : rowGap, ";") : '', columnGap ? "column-gap: ".concat((0,isNumber/* isNumber */.h)(columnGap) ? (0,pixelize/* pixelize */.P)(columnGap) : columnGap, ";") : '', justify ? "justify-items: ".concat(justify, ";") : '', align ? "align-items: ".concat(align, ";") : '', justifyContent ? "justify-content: ".concat(justifyContent, ";") : '', alignContent ? "align-content: ".concat(alignContent, ";") : '', autoColumns ? "grid-auto-columns: ".concat(autoColumns, ";") : '', autoRows ? "grid-auto-rows: ".concat(autoRows, ";") : '', autoFlow ? "grid-auto-flow: ".concat(autoFlow, ";") : '');
};

// EXTERNAL MODULE: ./utilities/makeElementSize/makeElementSize.ts
var makeElementSize = __webpack_require__(23787);
;// CONCATENATED MODULE: ./components/ui/Grid/libs/Container/styles.ts



function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b01ce3c0-0"
})(styles_templateObject(), function(param) {
    var width = param.width;
    return (0,makeElementSize/* makeElementSize */.o)(width);
}, function(param) {
    var height = param.height;
    return (0,makeElementSize/* makeElementSize */.o)(height);
}, gridContainer);

;// CONCATENATED MODULE: ./components/ui/Grid/libs/Container/component.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Container = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Wrapper, _objectSpread({}, props, {
        children: children
    }));
};


;// CONCATENATED MODULE: ./components/ui/Grid/libs/Container/index.ts



;// CONCATENATED MODULE: ./styles/mixins/grid/item.ts

function item_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function item_templateObject() {
    var data = item_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    item_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var gridItem = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, columnStart = ref.columnStart, columnEnd = ref.columnEnd, rowStart = ref.rowStart, rowEnd = ref.rowEnd, area = ref.area, justify = ref.justify, align = ref.align;
    return (0,styled_components_browser_esm/* css */.iv)(item_templateObject(), columnStart ? "grid-column-start: ".concat(columnStart, ";") : '', columnEnd ? "grid-column-end: ".concat(columnEnd, ";") : '', rowStart ? "grid-row-start: ".concat(rowStart, ";") : '', rowEnd ? "grid-row-end: ".concat(rowEnd, ";") : '', area ? "grid-area: ".concat(area, ";") : '', justify ? "justify-self: ".concat(justify, ";") : '', align ? "align-self: ".concat(align, ";") : '');
};

;// CONCATENATED MODULE: ./components/ui/Grid/libs/Item/styles.ts


function Item_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Item_styles_templateObject() {
    var data = Item_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    Item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6f7ee02a-0"
})(Item_styles_templateObject(), gridItem);

;// CONCATENATED MODULE: ./components/ui/Grid/libs/Item/component.tsx


function component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Item = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = component_objectWithoutProperties(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styles_Wrapper, component_objectSpread({}, props, {
        children: children
    }));
};


;// CONCATENATED MODULE: ./components/ui/Grid/libs/Item/index.ts



;// CONCATENATED MODULE: ./components/ui/Grid/component.tsx



function Grid_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Grid_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Grid_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Grid_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Grid_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Grid_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Grid = function(_param) {
    var children = _param.children, _container = _param.container, container = _container === void 0 ? false : _container, _item = _param.item, item = _item === void 0 ? false : _item, props = Grid_component_objectWithoutProperties(_param, [
        "children",
        "container",
        "item"
    ]);
    if (container) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Container, Grid_component_objectSpread({}, props, {
        children: children
    })));
    if (item) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Item, Grid_component_objectSpread({}, props, {
        children: children
    })));
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Specify a grid type: “container” or “item”"
    }));
};


;// CONCATENATED MODULE: ./components/ui/Grid/index.ts



/***/ }),

/***/ 67022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ui/Icon/index.ts + 3 modules
var Icon = __webpack_require__(37033);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50445);
// EXTERNAL MODULE: ./styles/theme/palette/index.ts + 1 modules
var palette = __webpack_require__(42389);
// EXTERNAL MODULE: ./utilities/pixelize/pixelize.ts
var pixelize = __webpack_require__(60548);
;// CONCATENATED MODULE: ./components/ui/Loader/styles.ts


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be77b84a-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return (0,pixelize/* pixelize */.P)(size);
}, function(param) {
    var size = param.size;
    return (0,pixelize/* pixelize */.P)(size);
});

;// CONCATENATED MODULE: ./components/ui/Loader/component.tsx





var Loader = function(param) {
    var _size = param.size, size = _size === void 0 ? 48 : _size, _color = param.color, color = _color === void 0 ? palette/* palette.Core.WHITE */.D.QY.WHITE : _color;
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
            icon: theme.icons.loader.Loader,
            size: size,
            color: color
        })
    }));
};

;// CONCATENATED MODULE: ./components/ui/Loader/index.ts



/***/ }),

/***/ 25013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ pageWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50445);

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        "px;\n  position: relative;\n  min-height: calc(",
        ");\n  margin-bottom: ",
        "px;\n\n  @media screen and (max-width: 1180px) {\n    padding-top: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var pageWrapper = function() {
    var useFullHeight = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, mt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90, mb = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 96;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), mt, useFullHeight ? '100vh' : 'calc(100vh - 90px)', mb);
};


/***/ }),

/***/ 64112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatPrice; }
/* harmony export */ });
var formatPrice = function(price) {
    /**
   * The Intl.NumberFormat object enables language-sensitive number formatting.
   * @link {https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-strings}
   * @link {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat}
   */ var formatter = new Intl.NumberFormat('kk-KZ');
    return "".concat(formatter.format(price), " ₸");
};


/***/ })

}]);